(() => {
  let headerFrame = null;

  function syncHeaderState() {
    const header = document.querySelector('[data-ignor-header]');
    if (!header) return;

    const isHomepage = document.body.classList.contains('template-index');
    header.classList.toggle('is-home-overlay', isHomepage);

    if (!isHomepage) {
      header.classList.add('is-scrolled');
      return;
    }

    header.classList.toggle('is-scrolled', window.scrollY > 28);
  }

  function requestHeaderSync() {
    if (headerFrame) return;
    headerFrame = window.requestAnimationFrame(() => {
      syncHeaderState();
      headerFrame = null;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    syncHeaderState();
    window.addEventListener('scroll', requestHeaderSync, { passive: true });
  });
})();
